interface AmbientBackgroundProps {
  variant?: 'full' | 'subtle';
}

const AmbientBackground = ({ variant = 'full' }: AmbientBackgroundProps) => {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(80,188,20,0.22),_transparent_32%),radial-gradient(circle_at_bottom_right,_rgba(34,197,94,0.16),_transparent_30%),linear-gradient(135deg,_#07120a_0%,_#0b1d10_45%,_#13271a_100%)]" />
      <div className="absolute inset-0 opacity-30 [background-image:linear-gradient(rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.04)_1px,transparent_1px)] [background-size:64px_64px]" />
      {variant === 'full' ? (
        <>
          <div className="absolute -left-16 top-16 h-80 w-80 rounded-full bg-brand-500/25 blur-3xl animate-blob" />
          <div className="absolute right-0 top-40 h-96 w-96 rounded-full bg-emerald-400/15 blur-3xl animate-blob [animation-delay:2s]" />
        </>
      ) : null}
    </div>
  );
};

export default AmbientBackground;
